import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';

const PriceI = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.container} ${styles.sizeBodyText} ${color ? styles[color] : ''}`}>
		  <div className={`${styles.prices} ${styles.centered}`}>
			  <div className={`${styles.priceContainer} ${styles.flexEnd}`}>
				  <div className={`${styles.price} ${styles.sizeBodyText}`}>
					  {priceData.price}
				  </div>
				  <div className={styles.currencySmall}>
					  {priceData.curr}
				  </div>
			  </div>
		  </div>
	  </div>
	);
}

PriceI.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceI;
